import { Component, OnInit, ViewChild } from "@angular/core";
import { FbUserSeedingService } from "../../_services/fb-user-seeding.service";
import { Account } from "../../_models/account";
import { ToastrService } from "ngx-toastr";
import {
  TreeGridComponent,
  FilterService,
} from "@syncfusion/ej2-angular-treegrid";
import {
  SelectionSettingsModel,
  ToolbarItems,
  GridComponent,
  RowSelectEventArgs,
  RowDeselectEventArgs,
  FilterSettingsModel,
} from "@syncfusion/ej2-angular-grids";
import { ClickEventArgs } from "@syncfusion/ej2-navigations";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import { BsModalService } from "ngx-bootstrap/modal";
import { L10n } from "@syncfusion/ej2-base";
import { FbUserSeeding } from "../../_models/fb-user-seeding";
import { ProjectsService } from "../../_services/projects.service";
import { AccountsService } from "../../_services/accounts.service";
import { VPSHostingService } from "../../_services/vps-hosting.service";
import { SeedingService } from "../../_services/seeding.service";
import { ConfigPermissionOption } from "../../_helpers/config-permission-option";
import { ProxyList } from "../../_helpers/proxy";
import {
  PageSettingsModel,
  SortSettingsModel,
  EditService,
  CommandColumnService,
} from "@syncfusion/ej2-angular-treegrid";
import { GlobalService } from "app/_services/global.service";

L10n.load({
  "de-DE": {
    treegrid: {
      //'Add': 'Thêm mới',
      // 'Save': 'Lưu',
    },
    pager: {
      currentPageInfo: "Trang {0}/{1}",
      totalItemsInfo: "({0} Tài khoản)",
    },
  },
});

@Component({
  selector: "app-fb-user-seeding",
  templateUrl: "./fb-user-seeding.component.html",
  styleUrls: ["./fb-user-seeding.component.scss"],
  providers: [
    FbUserSeedingService,
    FilterService,
    SeedingService,
    EditService,
    CommandColumnService,
  ],
})
export class FBUserSeedingComponent implements OnInit {
  file: any;

  public data: Object[];
  public sortSettings: SortSettingsModel;
  public pageSettings: PageSettingsModel;
  public commands: Object[];
  public fbUserSeedings: Array<any>;
  public toolbarOption: string[];
  public searchSettings: Object;
  public editSettings: Object;
  public isLoading = false;
  public treeGridObj: TreeGridComponent;
  public toolbar: any[];
  public selectionOptions: SelectionSettingsModel;
  public filterSettings: FilterSettingsModel;

  accountLogin: Account;

  userId = "";
  username = "";
  password = "";
  email = "";
  status = false;
  facebookCookie = "";
  tokenUser = "";
  isEdit = false;
  nameErrorMsg = "";
  adminPasswordErrorMsg = "";
  emailErrorMsg = "";
  passwordErrorMsg = "";
  userIdErrorMsg = "";
  proxyHostErrorMsg = "";
  proxyPortErrorMsg = "";
  usernameErrorMsg = "";
  passwordConfErrorMsg = "";
  passwordMatchErrorMsg = "";
  facebookCookieErrorMsg = "";
  messengerCookieErrorMsg = "";
  tokenErrorMsg = "";
  userAgentErrorMsg = "";
  projectErrorMsg = "";
  vpsHostingErrorMsg = "";
  userExitsList = "";
  accountId = "";
  accountName = "";
  allowedToChange = false;
  typeStr = "";

  type = "all";

  pageSize = 20;

  public currentProject;
  public fbUserSeeding: FbUserSeeding;
  public currentFbUserSeeding: FbUserSeeding;
  public adminPassword = "";
  public projects: Array<any>;
  public accounts: Array<any>;

  accountDepartmentList = [];

  modalRef: BsModalRef;
  modalRef1: BsModalRef;

  modalConfirmInitAll: BsModalRef;
  isShowProcessBar = false;
  percentInit = "0%";
  totalInit = 0;
  initSuccess = 0;
  initFail = 0;
  checkAccount = true;

  public config2 = {
    keyboard: false,
    backdrop: "static",
    class: "modal-lg",
  };
  public config1 = {
    keyboard: false,
    backdrop: "static",
    class: "modal-sm",
  };
  public config3 = {
    keyboard: false,
    backdrop: "static",
    class: "modal-md",
  };
  public config4 = {
    keyboard: false,
    backdrop: "static",
    class: "modal-md",
  };
  differ: any;

  // lọc theo chủ để
  public itemList: Array<any>;
  selectedItems = [{ id: -1, itemName: "Chọn tất cả" }];
  settings = {};

  // chọn chủ đề
  public itemList2: Array<any>;
  selectedItems2 = [];
  settings2 = {};

  // lọc theo kiểu tài khoản
  public itemListTypeAccount: Array<any>;
  public itemListEditTypeAccount: Array<any>;
  selectedTypeAccountItems = [
    { id: -1, itemName: "Chọn tất cả", value: "all" },
  ];
  selectedEditTypeAccountItems = [];
  typeAccountSettings = {};

  editTypeAccountSettings = {};

  // cấu hình chủ đề
  public projectList: Array<any>;
  projectSelected = [];
  projectSettings = {};
  projectSelectedAdd = [];

  // gán tài khoản tương tác cho TĐV
  public accountList: Array<any>;
  accountSelected = [];
  accountSettings = {};
  accountSelectedAdd = [];

  // sao chep tài khoản
  public copyAccount = [];
  copyAccountProjectSelected = [];

  accountFromTxt = [];
  // chọn VPS Hosting
  public vpsHostingList: Array<any>;
  vpsHostingSelected = [];
  vpsHostingSettings = {
    text: "Chọn VPS Hosting ...",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    classes: "myclass custom-class",
    enableSearchFilter: true,
    singleSelection: true,
    disabled: false,
  };

  typeAccount = "all";
  projectId = "";
  statusAccount = "all";
  actionViewSeedingAccount = false;
  actionSeedingAccountManager = false;
  hasVnptAvt = '0';
  proxyList = [];
  public configPermissionOption = ConfigPermissionOption;
  constructor(
    private fbUserSeedingService: FbUserSeedingService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private projectsService: ProjectsService,
    private accountsService: AccountsService,
    private vpsHostingService: VPSHostingService,
    private seedingService: SeedingService,
    private globalService: GlobalService
  ) {
    this.actionViewSeedingAccount = this.globalService.canPermission(
      this.configPermissionOption.actionViewSeedingAccount
    );
    this.actionSeedingAccountManager = this.globalService.canPermission(
      this.configPermissionOption.actionSeedingAccountManager
    );
    this.proxyList = ProxyList.list.split("\n");
    // let test = this.getProxyAuth('103.187.169.10:49161');
    this.test();
  }

  @ViewChild("grid")
  public grid: GridComponent;

  ngOnInit(): void {
    // this.sortSettings = { columns: [ { field: 'username', direction: 'Descending' }]  };

    this.itemListTypeAccount = [];
    this.itemListEditTypeAccount = [];

    this.pageSettings = { pageSize: this.pageSize };
    this.editSettings = {
      allowAdding: true,
      allowEditing: true,
      allowDeleting: true,
      showDeleteConfirmDialog: true,
      allowEditOnDblClick: false,
      mode: "Dialog", //Cell, Row, Cell,Dialog
    };

    this.itemList = [];
    this.itemList2 = [];
    this.settings = {
      text: "Chọn chủ đề ...",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      classes: "myclass custom-class",
      enableSearchFilter: true,
      singleSelection: true,
    };
    this.typeAccountSettings = {
      text: "Chọn kiểu tài khoản ...",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      classes: "myclass custom-class",
      enableSearchFilter: true,
      singleSelection: true,
    };

    this.editTypeAccountSettings = {
      text: "Chọn kiểu tài khoản ...",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      classes: "myclass custom-class",
      // enableSearchFilter: true,
      singleSelection: false,
    };

    this.settings2 = {
      text: "Chọn chủ đề ...",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      classes: "myclass custom-class",
      enableSearchFilter: true,
      //singleSelection: true
      badgeShowLimit: 2,
    };

    this.accountSettings = {
      text: "Chọn tổng đài viên ...",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      classes: "myclass custom-class",
      enableSearchFilter: true,
      singleSelection: true,
      //badgeShowLimit: 2
    };

    this.commands = [
      // { type: 'Add', title: 'Thêm mới', buttonOption: { iconCss: ' e-icons e-add', cssClass: 'e-flat', click: this.onClick.bind(this) } },
      {
        type: "Edit",
        title: "Sửa đổi",
        buttonOption: { iconCss: " e-icons e-edit", cssClass: "e-flat" },
      },
      {
        type: "Delete",
        title: "Xóa",
        buttonOption: { iconCss: "e-icons e-delete", cssClass: "e-flat" },
      },
      {
        type: "Save",
        buttonText: "heute",
        watermarkText: "Lưu",
        title: "Lưu",
        buttonOption: { iconCss: "e-icons e-update", cssClass: "e-flat" },
      },
      {
        type: "Cancel",
        title: "Hủy bỏ",
        buttonOption: { iconCss: "e-icons e-cancel-icon", cssClass: "e-flat" },
      },
    ];

    this.searchSettings = {
      fields: [
        "username",
        "userId",
        "vps_hosting_ip",
        "vps_hosting_name",
        "type",
        "accountName",
      ],
      hierarchyMode: "Child",
      operator: "contains",
      key: "",
      ignoreCase: true,
    };

    //this.treeGridObj.hideColumns('ID') //hide by HeaderText
    this.getProject();
    this.getAccounts();
    this.getAllType();
    this.getVPSHosting();

    this.selectionOptions = {
      type: "Multiple",
      mode: "Row",
      cellSelectionMode: "Flow",
      checkboxOnly: false,
    };

    this.accountLogin =
      localStorage.getItem("currentSmmAccount") !== undefined &&
      localStorage.getItem("currentSmmAccount") !== "undefined"
        ? JSON.parse(localStorage.getItem("currentSmmAccount"))
        : {};
    // console.log(this.accountLogin)
    if (this.accountLogin.admin || this.actionSeedingAccountManager) {
      this.toolbar = ["Search"];
      if (this.accountLogin.admin) {
        this.toolbar.push({
          text: "Thêm mới",
          tooltipText: "Thêm mới tài khoản tương tác",
          prefixIcon: "e-expand",
          id: "addUserSeeding",
        });
      }
      if (this.accountLogin.admin) {
        this.toolbar.push({
          text: "Sao chép tài khoản",
          tooltipText: " Sao chép tài khoản tương tác",
          prefixIcon: "e-expand",
          id: "copyAccount",
        });
      }
      if (this.accountLogin.admin || this.actionSeedingAccountManager) {
        this.toolbar.push({
          text: "Cấp tài khoản cho TĐV",
          tooltipText: " Gán tài khoản cho TDV",
          prefixIcon: "e-expand",
          id: "assigneToAccount",
        });
      }
      if (this.accountLogin.admin || this.actionSeedingAccountManager) {
        this.toolbar.push({
          text: "Gỡ tài khoản khỏi TĐV",
          tooltipText: " Gỡ tài khoản khỏi TĐV",
          prefixIcon: "e-cancel",
          id: "releaseAccount",
        });
      }
      if (this.accountLogin.admin) {
        this.toolbar.push({
          text: "Thay đổi kiểu tài khoản",
          tooltipText: " Thay đổi kiểu tài khoản",
          prefixIcon: "e-edit",
          id: "editTypeAccount",
        });
        this.toolbar.push({
          text: "Xóa tài khoản",
          tooltipText: "Xóa tài khoản",
          prefixIcon: "e-cancel",
          id: "deleteAccount",
        });
        this.toolbar.push({
          text: "Reup tài khoản",
          tooltipText: "Reup tài khoản",
          prefixIcon: "e-expand",
          id: "reupAccount",
        });
      }
    } else {
      this.toolbar = [];
    }

    // đổi màu hàng tiêu đề
    setTimeout(() => {
      var header = document.getElementsByClassName("e-headercell");
      for (var i = 0; i < header.length; i++) {
        header[i].setAttribute("style", "color: rebeccapurple;");
      }
      this.getListAccountSeeding();
    }, 100);
  }

  async test() {
    let test = await this.getProxyAuth("103.187.169.10:49161");
    // console.log(test)
  }

  wait(timeout) {
    return new Promise((resolve) => {
      setTimeout(resolve, timeout);
    });
  }

  changePageSize() {
    this.pageSettings = { pageSize: this.pageSize };
  }

  addType(event, typeStr) {
    if (typeStr === "typeStr") {
      if (this.typeStr !== "") {
        if (!this.fbUserSeeding.type.includes(this.typeStr)) {
          this.fbUserSeeding.type.push(this.typeStr);
        }

        this.typeStr = "";
      }
    }
  }

  releaseAccount(releaseAccount) {
    if (this.copyAccount.length == 0 || this.copyAccount == null) {
      this.toastrService.warning(
        "Bạn cần chọn ít nhất 1 tài khoản!",
        "Thông báo"
      );
      return;
    }
    this.modalRef = this.modalService.show(releaseAccount, this.config3);
  }

  deleteAccounts(deleteAccount) {
    if (this.copyAccount.length == 0 || this.copyAccount == null) {
      this.toastrService.warning(
        "Bạn cần chọn ít nhất 1 tài khoản!",
        "Thông báo"
      );
      return;
    }
    this.modalRef = this.modalService.show(deleteAccount, this.config3);
  }

  editTypeAccount(editTypeAccount) {
    if (this.copyAccount.length == 0 || this.copyAccount == null) {
      this.toastrService.warning(
        "Bạn cần chọn ít nhất 1 tài khoản!",
        "Thông báo"
      );
      return;
    }

    this.modalRef = this.modalService.show(editTypeAccount, this.config4);
  }

  releaseAccountHandler() {
    let data = [];
    this.copyAccount.forEach(function (account) {
      data.push(account._id);
    });
    this.fbUserSeedingService.releaseAccount(data).subscribe((res) => {
      if (res.success) {
        this.copyAccount = [];
        this.toastrService.success(`${res.msg}`, "Thông báo");
        this.modalRef.hide();
        this.getListAccountSeeding();
      } else {
        this.toastrService.error(`${res.msg}`, "Thông báo");
      }
    });
  }

  deleteAccountHandler() {
    let accounts = [];
    this.copyAccount.forEach(function (account) {
      accounts.push({
        userId: account.userId,
        vps_hosting_ip: account.vps_hosting_ip,
      });
    });
    this.fbUserSeedingService
      .deleteAccount({ accounts: accounts })
      .subscribe((res) => {
        if (res.success) {
          this.copyAccount = [];
          this.toastrService.success(`${res.msg}`, "Thông báo");
          this.modalRef.hide();
          this.getListAccountSeeding();
        } else {
          this.toastrService.error(`${res.msg}`, "Thông báo");
        }
      });
  }

  getProxyAuth(host_port): any {
    const app = this;
    return new Promise(function (reslove, reject) {
      for (let j = 0; j < app.proxyList.length; j++) {
        if (app.proxyList[j].includes(host_port)) {
          reslove({
            proxyUser: app.proxyList[j].trim().split(":")[2],
            proxyPassword: app.proxyList[j].trim().split(":")[3],
          });
          break;
        }
      }
      reslove(null);
    });
  }

  //get chủ đề
  getProject() {
    this.projectsService.index().subscribe((res) => {
      let temp = {};
      temp["itemName"] = "Chọn tất cả";
      temp["id"] = -1;
      this.itemList.push(temp);

      this.projectList = res.data.projects;
      this.projectList.forEach(function (project, index) {
        project["itemName"] = project["name"];
        project["id"] = project["_id"];
      });

      this.itemList = this.itemList.concat(this.projectList);
      this.itemList2 = this.projectList;
    });
  }

  // get tài khoản TĐV
  getAccounts() {
    this.accountsService.index().subscribe((response) => {
      if (response.success) {
        this.accounts = response.data.accounts;
        this.isLoading = false;
        this.accounts.forEach(function (account, index) {
          account["id"] = account["_id"];
          account["itemName"] = account["username"];
        });
      }
    });
  }

  onTypeChange(item: any) {
    // console.log("onTypeChange")
    this.type = item.value;
    this.getListAccountSeeding();
  }

  //get all type accounts
  getAllType() {
    this.fbUserSeedingService.getAllType().subscribe((res) => {
      if (res.success) {
        // console.log("data = ", res.data)
        const data = res.data.typeAccounts;
        this.itemListTypeAccount = [
          { id: -1, itemName: "Chọn tất cả", value: "all" },
        ];
        this.itemListEditTypeAccount = [];
        for (let index in data) {
          this.itemListTypeAccount.push({
            id: Number(index),
            itemName: `${data[index]}`,
            value: `${data[index]}`,
          });
          this.itemListEditTypeAccount.push({
            id: Number(index),
            itemName: `${data[index]}`,
            value: `${data[index]}`,
          });
        }
      }
    });
  }

  //get danh sách vps hosting
  getVPSHosting() {
    this.vpsHostingService.index().subscribe((res) => {
      this.vpsHostingList = res.data.vpsHosting;
      this.vpsHostingList.forEach(function (vpsHosting, index) {
        vpsHosting["itemName"] = vpsHosting["ip"];
        vpsHosting["id"] = vpsHosting["_id"];
        vpsHosting["vps_hosting_name"] = vpsHosting["name"];
      });
    });
  }

  updateOrCreatAccount(accountInfo) {
    const app = this;
    return new Promise(function (reslove, reject) {
      app.fbUserSeedingService.updateOrCreate(accountInfo).subscribe(
        (res) => {
          if (res.success) {
            reslove(true);
          } else {
            reslove(false);
          }
        },
        () => {
          reslove(false);
        }
      );
    });
  }

  async initAccount(account, type = "INIT_ALL") {
    // const proxyAuth = await this.getProxyAuth(`${account.proxyHost}:${account.proxyPort}`);
    // if(proxyAuth) {
    let params = {
      username: account.username,
      ip: account.vps_hosting_ip,
      accessToken: account.tokenUser,
      userId: account.userId,
      userAgent: account.userAgent,
      facebookCookie: this.isJsonString(account.facebookCookie)
        ? JSON.parse(account.facebookCookie)
        : account.facebookCookie,
      messengerCookie: JSON.parse(account.messengerCookie),
      type: type,
      proxyHost: account.proxyHost,
      proxyPort: account.proxyPort,
      proxyUser: account.proxyUser,
      proxyPassword: account.proxyPassword,
      canChat: account.canChat || false,
      seedingPositive: account.seedingPositive || false,
      allow_seeding_bot: account.allow_seeding_bot || false,
      isCheckAccount: this.checkAccount,
    };

    const app = this;
    return new Promise(function (reslove, reject) {
      app.seedingService.checkAccount(params).subscribe(
        (res) => {
          if (res.success) {
            reslove(true);
          } else {
            reslove(false);
          }
        },
        () => {
          reslove(false);
        }
      );
    });

    // } else {
    //   console.log("nick khong ton tai proxy auth")
    // }
  }

  create() {
    this.vpsHostingSettings.disabled = false;
    if (this.check()) {
      //selectedItems2 là tất cả các chủ đề mà người dùng đã chọn ở trên form thêm
      if (this.selectedItems2.length == 0) {
        this.fbUserSeeding["project"] = null;
      } else {
        var objProject = [];
        this.selectedItems2.forEach(function (account, index) {
          let temp = {};
          temp["id"] = account["id"];
          temp["name"] = account["name"];
          temp["itemName"] = account["name"];
          temp["accountId"] = "";
          temp["accountName"] = "";
          objProject[index] = temp;
        });
        this.fbUserSeeding["project"] = objProject;
      }

      if (this.vpsHostingSelected.length > 0) {
        this.fbUserSeeding["vps_hosting_id"] =
          this.vpsHostingSelected[0].itemName;
        this.fbUserSeeding["vps_hosting_ip"] =
          this.vpsHostingSelected[0].itemName;
        this.fbUserSeeding["vps_hosting_name"] =
          this.vpsHostingSelected[0].itemName;
      } else {
        this.fbUserSeeding["vps_hosting_id"] = "";
        this.fbUserSeeding["vps_hosting_ip"] = "";
        this.fbUserSeeding["vps_hosting_name"] = "";
      }

      this.fbUserSeeding.image =
        "https://graph.facebook.com/" +
        this.fbUserSeeding.userId +
        "/picture?height=64&width=64";

      // goi api check tinh kha dung cua tai khoan
      this.seedingService
        .checkAccount({
          username: this.fbUserSeeding.username,
          ip: this.fbUserSeeding.vps_hosting_ip,
          accessToken: this.fbUserSeeding.tokenUser,
          userId: this.fbUserSeeding.userId,
          userAgent: this.fbUserSeeding.userAgent,
          facebookCookie: this.isJsonString(this.fbUserSeeding.facebookCookie)
            ? JSON.parse(this.fbUserSeeding.facebookCookie)
            : this.fbUserSeeding.facebookCookie,
          messengerCookie: JSON.parse(this.fbUserSeeding.messengerCookie),
          canChat: this.fbUserSeeding.canChat,
          seedingPositive: this.fbUserSeeding.seedingPositive,
          proxyHost: this.fbUserSeeding.proxyHost,
          proxyPort: this.fbUserSeeding.proxyPort,
          proxyUser: this.fbUserSeeding.proxyUser,
          proxyPassword: this.fbUserSeeding.proxyPassword,
          isCheckAccount: true,
          type: "create",
        })
        .subscribe(
          (response) => {
            if (response.success) {
              this.fbUserSeeding.status = true;
              this.fbUserSeedingService.create(this.fbUserSeeding).subscribe(
                (response) => {
                  if (response.success) {
                    this.toastrService.success(
                      "Tạo thành công tài khoản tương tác!",
                      "Thông báo"
                    );
                    this.modalRef.hide();

                    // update theo chủ đề đã chọn
                    if (this.selectedItems[0].id == -1) {
                      this.getListAccountSeeding();
                    } else {
                      this.fbUserSeedingService
                        .getUserByProject(this.selectedItems[0].id.toString())
                        .subscribe(
                          (res) => {
                            if (res.success) {
                              this.data = res.data.fbUserSeeding;
                            } else {
                              this.toastrService.error(
                                res.message,
                                "Thông báo"
                              );
                            }
                          },
                          (err) => {
                            this.toastrService.error(
                              "Có lỗi xảy ra khi kết nối tới máy chủ!",
                              "Thông báo"
                            );
                          }
                        );
                    }
                  } else {
                    this.toastrService.warning(response.message, "Thông báo");
                  }
                },
                (err) => {
                  this.toastrService.error("Có lỗi xảy ra!", "Lỗi");
                }
              );
            } else {
              this.toastrService.warning(
                "Tạo tài khoản tương tác không thành công",
                "Thông báo"
              );
            }
          },
          (err) => {
            this.toastrService.error("Có lỗi xảy ra!", "Lỗi");
          }
        );
    } else {
      this.toastrService.warning(
        "Chưa đủ thông tin hoặc thông tin không tính xác!",
        "Cảnh báo"
      );
    }
  }

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  editAccount(item, template_add_update) {
    this.fbUserSeeding = JSON.parse(JSON.stringify(item));
    this.currentFbUserSeeding = JSON.parse(JSON.stringify(item));
    this.isEdit = true;

    this.allowedToChange = item.allowedToChange;

    this.selectedItems2 = item.project;
    this.accountId = item.accountId;
    this.accountName = item.accountName;

    if (item.vps_hosting_id) {
      this.vpsHostingSelected = [
        {
          id: item.vps_hosting_ip,
          itemName: item.vps_hosting_ip,
          vps_hosting_name: item.vps_hosting_ip,
        },
      ];
    }
    this.adminPassword = "";
    this.usernameErrorMsg = "";
    this.emailErrorMsg = "";
    this.passwordMatchErrorMsg = "";
    this.adminPasswordErrorMsg = "";
    this.userIdErrorMsg = "";
    this.passwordErrorMsg = "";
    this.passwordConfErrorMsg = "";
    this.facebookCookieErrorMsg = "";
    this.projectErrorMsg = "";
    this.password = "";
    this.email = "";
    this.userAgentErrorMsg = "";
    this.messengerCookieErrorMsg = "";
    this.tokenErrorMsg = "";
    this.vpsHostingErrorMsg = "";
    this.modalRef = this.modalService.show(template_add_update, this.config2);
  }

  fileChanged(e) {
    this.file = e.target.files[0];

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      let projects = [];

      this.itemList2.forEach((project) => {
        projects.push({
          id: project.id,
          name: project.name,
          itemName: project.name,
        });
      });

      e.target.result
        .toString()
        .split("\r\n")
        .forEach((line) => {
          const accountInfo = line.split("|");
          // console.log(accountInfo,'accountInfo fileChanged')
          // const proxyAuth = this.getProxyAuth(`${accountInfo[3].split(':')[0]}:${accountInfo[3].split(':')[1]}`);
          const proxy = accountInfo[3].split(":");
          const accountInfoObject = {
            userId: accountInfo[0],
            username: `${accountInfo[1]}_${this.getRamdomNumber()} vnp`,
            tokenUser: "EAAU",
            facebookCookie: accountInfo[2],
            messengerCookie: JSON.stringify([]),
            userAgent:
              "Mozilla/5.0 (Linux; Android 10; Redmi Note 7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.185 Mobile Safari/537.36",
            canChat: false,
            allow_seeding_bot: false,
            seedingPositive: false,
            proxyHost: proxy[0].trim(),
            proxyPort: Number(proxy[1].trim()),
            type: [],
            vps_hosting_ip: accountInfo[4].trim(),
            isCheckAccount: true,
            vps_hosting_id: accountInfo[4].trim(),
            vps_hosting_name: accountInfo[4].trim(),
            email: "",
            project: projects,
            created_by: "admin",
            status: true,
            hasVnptAvt: accountInfo[6] ? true : false
          };
          if (proxy[2]) {
            accountInfoObject["proxyUser"] = proxy[2].trim();
            accountInfoObject["proxyPassword"] = proxy[3].trim();
          }

          if (accountInfo[5]) {
            accountInfoObject.type = JSON.parse(accountInfo[5]);
          }
          this.accountFromTxt.push(accountInfoObject);
        });
    };
    fileReader.readAsText(this.file);
  }
  getRamdomNumber(){
    const timestamp = new Date().getTime();
    const randomNum = Math.floor(Math.random() * 1000); // Tạo số ngẫu nhiên từ 0 đến 999
    const uniqueRandomNum = timestamp + randomNum;
    return uniqueRandomNum;
  }
  async processAccounts() {
    this.totalInit = this.accountFromTxt.length;
    this.initSuccess = 0;
    this.initFail = 0;
    this.percentInit = "0%";
    this.isShowProcessBar = true;
    for (let index = 0; index < this.accountFromTxt.length; index++) {
      let account = this.accountFromTxt[index];

      let resultFromSeedingIp = await this.initAccount(account, "create");
      if (resultFromSeedingIp) {
        // if(resultFromSeedingIp['success']) {
        //   account['status'] = true;
        // } else {
        //   account['status'] = false;
        // }
        this.initSuccess++;
        console.log("account : ", account);
        let resultFromDB = await this.updateOrCreatAccount(account);
        this.getListAccountSeeding();
      } else {
        this.initFail++;
      }
      this.percentInit =
        Math.round(
          ((this.initSuccess + this.initFail) / this.totalInit) * 100
        ) + "%";
    }
  }

  update() {
    if (this.check()) {
      let a = this.accountId;
      let b = this.accountName;

      var objProject = [];
      if (this.selectedItems2.length > 0) {
        this.selectedItems2.forEach(function (project, index) {
          let temp = {};
          temp["id"] = project["id"];
          temp["name"] = project["name"];
          temp["itemName"] = project["name"];
          temp["accountId"] = a;
          temp["accountName"] = b;
          objProject.push(temp);
        });
      } else {
        this.fbUserSeeding["project"] = null;
      }
      this.fbUserSeeding["project"] = objProject;

      if (this.vpsHostingSelected.length > 0) {
        this.fbUserSeeding["vps_hosting_id"] =
          this.vpsHostingSelected[0].itemName;
        this.fbUserSeeding["vps_hosting_ip"] =
          this.vpsHostingSelected[0].itemName;
        this.fbUserSeeding["vps_hosting_name"] =
          this.vpsHostingSelected[0].itemName;
      }

      this.fbUserSeeding["adminPassword"] = this.adminPassword;

      //goi api check tinh kha dung cua tai khoan
      if (
        this.fbUserSeeding.vps_hosting_ip !=
          this.currentFbUserSeeding.vps_hosting_ip ||
        this.fbUserSeeding.tokenUser != this.currentFbUserSeeding.tokenUser ||
        this.fbUserSeeding.userId != this.currentFbUserSeeding.userId ||
        this.fbUserSeeding.userAgent != this.currentFbUserSeeding.userAgent ||
        this.fbUserSeeding.facebookCookie !=
          this.currentFbUserSeeding.facebookCookie ||
        this.fbUserSeeding.messengerCookie !=
          this.currentFbUserSeeding.messengerCookie ||
        this.fbUserSeeding.status == false
      ) {
        this.seedingService
          .checkAccount({
            ip: this.fbUserSeeding.vps_hosting_ip,
            accessToken: this.fbUserSeeding.tokenUser,
            userId: this.fbUserSeeding.userId,
            canChat: this.fbUserSeeding.canChat,
            seedingPositive: this.fbUserSeeding.seedingPositive,
            allow_seeding_bot: this.fbUserSeeding.allow_seeding_bot,
            username: this.fbUserSeeding.username,
            userAgent: this.fbUserSeeding.userAgent,
            facebookCookie: this.isJsonString(this.fbUserSeeding.facebookCookie)
              ? JSON.parse(this.fbUserSeeding.facebookCookie)
              : this.fbUserSeeding.facebookCookie,
            messengerCookie: JSON.parse(this.fbUserSeeding.messengerCookie),
            proxyHost: this.fbUserSeeding.proxyHost,
            proxyPort: this.fbUserSeeding.proxyPort,
            proxyUser: this.fbUserSeeding.proxyUser,
            proxyPassword: this.fbUserSeeding.proxyPassword,
            isCheckAccount: true,
            type: "update",
          })
          .subscribe(
            (response) => {
              if (response.success) {
                this.fbUserSeeding.status = true;
                this.fbUserSeedingService
                  .update(this.fbUserSeeding.userId, this.fbUserSeeding)
                  .subscribe(
                    (response) => {
                      this.getAllType();
                      if (response.success) {
                        this.isLoading = false;
                        this.toastrService.success(
                          "Chỉnh sửa thành công!",
                          "Thông báo"
                        );
                        // update theo chủ đề đã chọn
                        if (this.selectedItems[0].id == -1) {
                          this.getListAccountSeeding();
                        } else {
                          this.fbUserSeedingService
                            .getUserByProject(
                              this.selectedItems[0].id.toString()
                            )
                            .subscribe(
                              (res) => {
                                if (res.success) {
                                  this.data = res.data.fbUserSeeding;
                                } else {
                                  this.toastrService.error(
                                    res.message,
                                    "Thông báo"
                                  );
                                }
                              },
                              (err) => {
                                this.toastrService.error(
                                  "Có lỗi xảy ra khi kết nối tới máy chủ!",
                                  "Thông báo"
                                );
                              }
                            );
                        }
                        this.modalRef.hide();
                      } else {
                        this.toastrService.warning(
                          response.message,
                          "Thông báo"
                        );
                      }
                    },
                    (err) => {
                      this.toastrService.error("Có lỗi xảy ra!", "Lỗi");
                    }
                  );
              } else {
                this.toastrService.warning(response.message, "Thông báo");
              }
            },
            (err) => {
              this.toastrService.error("Có lỗi xảy ra!", "Lỗi");
            }
          );
      } else {
        // nếu chỉ sửa các thông tin liên quan đến quản lý ở ipcc thì k cần gọi api
        this.fbUserSeedingService
          .update(this.fbUserSeeding.userId, this.fbUserSeeding)
          .subscribe(
            (response) => {
              if (response.success) {
                this.isLoading = false;
                this.toastrService.success(
                  "Chỉnh sửa thành công!",
                  "Thông báo"
                );
                this.getAllType();
                // update theo chủ đề đã chọn
                if (this.selectedItems[0].id == -1) {
                  this.getListAccountSeeding();
                } else {
                  this.fbUserSeedingService
                    .getUserByProject(this.selectedItems[0].id.toString())
                    .subscribe(
                      (res) => {
                        if (res.success) {
                          this.data = res.data.fbUserSeeding;
                        } else {
                          this.toastrService.error(res.message, "Thông báo");
                        }
                      },
                      (err) => {
                        this.toastrService.error(
                          "Có lỗi xảy ra khi kết nối tới máy chủ!",
                          "Thông báo"
                        );
                      }
                    );
                }
                this.modalRef.hide();
              } else {
                this.toastrService.warning(response.message, "Thông báo");
              }
            },
            (err) => {
              this.toastrService.error("Có lỗi xảy ra!", "Lỗi");
            }
          );
      }
    } else {
      this.toastrService.warning(
        "Chưa đủ thông tin hoặc thông tin không chính xác!",
        "Cảnh báo"
      );
    }
  }

  check() {
    this.checkProxy();
    this.checkUserId();
    this.checkUsername();
    this.checkEmail();
    //this.checkPassword();
    this.checkVpshosting();
    // this.checkFacebookCookie();
    this.checkProject();
    this.checkToken();
    this.checkMessengerCookie();
    this.checkUserAgent();

    return (
      !this.proxyPortErrorMsg &&
      !this.proxyHostErrorMsg &&
      !this.userIdErrorMsg &&
      !this.usernameErrorMsg &&
      !this.emailErrorMsg &&
      !this.passwordErrorMsg &&
      !this.passwordMatchErrorMsg &&
      !this.facebookCookieErrorMsg &&
      !this.projectErrorMsg &&
      !this.tokenErrorMsg &&
      !this.messengerCookieErrorMsg &&
      !this.userAgentErrorMsg &&
      !this.vpsHostingErrorMsg
    );
  }

  checkProxy() {
    this.proxyHostErrorMsg = "";
    this.proxyPortErrorMsg = "";
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        this.fbUserSeeding.proxyHost
      )
    ) {
    } else {
      this.proxyHostErrorMsg = "Proxy Host không đúng định dạng";
    }
    if (!this.fbUserSeeding.proxyPort) {
      this.proxyPortErrorMsg == "Proxy Port không được để trống";
    }
  }

  async addFbUserSeeding(
    args: ClickEventArgs,
    template_add_update,
    copy_account,
    assigne_account,
    releaseAccount,
    editTypeAccount,
    deleteAccount
  ) {
    this.vpsHostingSettings.disabled = false;
    if (args.item.id === "releaseAccount") {
      this.releaseAccount(releaseAccount);
    }
    if (args.item.id === "deleteAccount") {
      this.deleteAccounts(deleteAccount);
    }
    if (args.item.id === "addUserSeeding") {
      //TH1: Thêm mới tài khoản tương tác
      this.fbUserSeeding = new FbUserSeeding();
      this.fbUserSeeding.status = true;
      this.fbUserSeeding.userId = "";
      this.projectSelectedAdd = null;
      this.userId = "";
      this.username = "";
      this.password = "";
      this.email = "";
      this.status = true;
      this.facebookCookie = "";
      this.tokenUser = "";
      this.isEdit = false;
      this.nameErrorMsg = "";
      this.adminPassword = "";

      this.userIdErrorMsg = "";
      this.usernameErrorMsg = "";
      this.emailErrorMsg = "";
      this.passwordErrorMsg = "";
      this.passwordConfErrorMsg = "";
      this.facebookCookieErrorMsg = "";
      this.projectErrorMsg = "";
      this.vpsHostingErrorMsg = "";
      this.selectedItems2 = null;
      this.vpsHostingSelected = null;
      this.tokenErrorMsg = "";
      this.messengerCookieErrorMsg = "";
      this.userAgentErrorMsg = "";
      this.modalRef = this.modalService.show(template_add_update, this.config2);
    } else if (args.item.id === "copyAccount") {
      // TH2: sao chép tài khoản tương tác
      // nếu chưa chọn tài khoản nào thì thông báo
      if (this.copyAccount.length == 0 || this.copyAccount == null) {
        this.toastrService.warning(
          "Bạn cần chọn ít nhất 1 tài khoản!",
          "Thông báo"
        );
        return;
      }

      this.copyAccountProjectSelected = null;
      this.modalRef = this.modalService.show(copy_account, {
        keyboard: false,
        backdrop: "static",
        class: "modal-md",
      });
    } else if (args.item.id === "assigneToAccount") {
      // TH3: Gán tài khoản tương tác cho TĐV
      this.fbUserSeeding = new FbUserSeeding();
      this.fbUserSeeding.allowedToChange = false;

      // nếu chưa chọn tài khoản nào thì thông báo
      if (this.copyAccount.length == 0 || this.copyAccount == null) {
        this.toastrService.warning(
          "Bạn cần chọn ít nhất 1 tài khoản!",
          "Thông báo"
        );
        return;
      }
      //nếu chọn "tất cả chủ đề" thì lấy tất cả account
      if (this.selectedItems[0].id == -1) {
        this.accountDepartmentList = this.accounts;
      } else {
        let projectId = this.selectedItems[0].id;
        var departmentList = [];
        // lấy ra tất cả các phòng ban đang được gán cho chủ đề này
        this.projectList.forEach(function (project, index) {
          if (projectId == project._id) {
            departmentList = project.departments;
          }
        });

        var temp = [];
        if (departmentList.length > 0) {
          // lấy tất cả acc thuộc các phòng ban trên
          this.accounts.forEach(function (account, index) {
            if (
              account.department != null &&
              account.department._id != "undefined"
            ) {
              var i = 0;
              for (i = 0; i < departmentList.length; i++) {
                if (
                  account.department._id.normalize() ===
                  departmentList[i]._id.normalize()
                ) {
                  temp.push(account);
                  break;
                }
              }
            }
          });

          this.accountDepartmentList = temp;
        }
      }
      this.accountSelected = null;

      // lấy danh sách các tài khoản TĐV
      this.modalRef = this.modalService.show(assigne_account, this.config3);
      setTimeout(() => {
        $(".pull-left.selected-item-item.btn.btn-default.btn-xs").css({
          border: "1px solid rgba(145, 142, 142, 0.52)",
          color: "black",
        });
        $(".close").css({ "padding-top": "0px", color: "red" });
        $(
          ".btn.btn-default.btn-secondary.form-control.selected-container-item"
        ).css({
          height: "40px",
          border: "1px solid rgba(145, 142, 142, 0.52)",
        });
      }, 200);
    } else if (args.item.id === "editTypeAccount") {
      this.editTypeAccount(editTypeAccount);
    } else if (args.item.id === "reupAccount") {
      this.initFail = 0;
      this.initSuccess = 0;
      this.isShowProcessBar = true;
      this.totalInit = this.copyAccount.length;
      this.percentInit = "0%";
      for (let index = 0; index < this.copyAccount.length; index++) {
        let temp = this.copyAccount[index];
        let account = {
          userId: temp.userId,
          username: temp.username,
          tokenUser: "EAAU",
          facebookCookie: temp.facebookCookie,
          messengerCookie: temp.messengerCookie,
          userAgent: temp.userAgent ||
            "Mozilla/5.0 (Linux; Android 10; Redmi Note 7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.185 Mobile Safari/537.36",
          canChat: temp.canChat,
          allow_seeding_bot: temp.allow_seeding_bot,
          seedingPositive: temp.seedingPositive,

          proxyHost: temp.proxyHost,
          proxyPort: temp.proxyPort,
          proxyUser: temp.proxyUser,
          proxyPassword: temp.proxyPassword,
          type: temp.type,
          vps_hosting_ip: temp.vps_hosting_ip,
          isCheckAccount: temp.isCheckAccount,
          vps_hosting_id: temp.vps_hosting_id,
          vps_hosting_name: temp.vps_hosting_name,
          email: temp.email,
          project: temp.project,
          created_by: temp.created_by,
          status: temp.status,
        };

        let resultFromSeedingIp = await this.initAccount(account, "update");
        if (resultFromSeedingIp) {
          // if(resultFromSeedingIp['success']) {
          //   account['status'] = true;
          // } else {
          //   account['status'] = false;
          // }
          this.initSuccess++;
          account["status"] = true;
        } else {
          this.initFail++;
          account["status"] = false;
        }
        this.copyAccount[index] = account.status;
        await this.updateOrCreatAccount(account);

        this.percentInit =
          Math.round(
            ((this.initSuccess + this.initFail) / this.totalInit) * 100
          ) + "%";
      }
      this.getListAccountSeeding();

      this.copyAccount = [];
    }
  }

  rowSelected(args: RowSelectEventArgs) {
    let selectedrecords: Object[] = this.grid.getSelectedRecords(); // Get the selected records.
    this.copyAccount = selectedrecords;
    setTimeout(() => {
      var checkselect = document.getElementsByClassName("e-frame");
      var rowIndex = args.rowIndex;
      for (var i = 0; i < checkselect.length; i++) {
        if (rowIndex == i - 1) {
          checkselect[i].className = checkselect[i].className.replace(
            "e-uncheck",
            "e-check"
          );
        }
      }
    }, 100);
  }

  rowDeselected(args: RowDeselectEventArgs) {
    let selectedrecords: Object[] = this.grid.getSelectedRecords(); // Get the selected records.
    this.copyAccount = selectedrecords;
    setTimeout(() => {
      if (!args.rowIndex[1]) {
        var index = args.rowIndex[0];
        var checkselect = document.getElementsByClassName("e-frame");
        for (var i = 0; i < checkselect.length; i++) {
          if (i != 0 && i - 1 == index) {
            checkselect[i].className = checkselect[i].className.replace(
              "e-check",
              "e-uncheck"
            );
          }
        }
        // backgroup
        var backgroundSelect = document.getElementsByClassName("e-gridchkbox");
        for (var i = 0; i < backgroundSelect.length; i++) {
          if (args.rowIndex == i) {
            backgroundSelect[i].className = backgroundSelect[
              i
            ].className.replace("e-cellselectionbackground", "");
          }
        }
      }
    }, 100);
  }

  deleteAccountConfirm(item, template_delete) {
    this.fbUserSeeding = item;
    this.modalRef1 = this.modalService.show(template_delete, {
      keyboard: false,
      backdrop: "static",
      class: "modal-md",
    });
  }

  delete() {
    this.seedingService
      .removeUser({
        ip: this.fbUserSeeding.vps_hosting_ip,
        userId: this.fbUserSeeding.userId,
      })
      .subscribe(
        (response) => {
          if (response.success) {
            this.fbUserSeedingService
              .delete(this.fbUserSeeding.userId)
              .subscribe(
                (response) => {
                  if (response.success) {
                    this.modalRef1.hide();
                    this.toastrService.success(
                      "Xóa tài khoản tương tác thành công!",
                      "Thông báo"
                    );

                    // update theo chủ đề đã chọn
                    if (this.selectedItems[0].id == -1) {
                      this.getListAccountSeeding();
                    } else {
                      this.fbUserSeedingService
                        .getUserByProject(this.selectedItems[0].id.toString())
                        .subscribe(
                          (res) => {
                            if (res.success) {
                              this.data = res.data.fbUserSeeding;
                            } else {
                              this.toastrService.error(
                                res.message,
                                "Thông báo"
                              );
                            }
                          },
                          (err) => {
                            this.toastrService.error(
                              "Có lỗi xảy ra khi kết nối tới máy chủ!",
                              "Thông báo"
                            );
                          }
                        );
                    }
                  } else {
                    this.modalRef1.hide();
                    this.toastrService.warning(response.message, "Thông báo");
                  }
                },
                (err) => {
                  this.toastrService.error("Có lỗi xảy ra!", "Lỗi");
                }
              );
          } else {
            this.modalRef1.hide();
            this.toastrService.warning(
              "xóa tài khoản tương tác không thành công",
              "Thông báo"
            );
            // console.log('gọi api xóa tài khoản tương tác trả về false');
          }
        },
        () => {
          this.toastrService.error("Có lỗi xảy ra!", "Lỗi");
        }
      );
  }

  editTypeAccountHandle() {
    this.fbUserSeedingService
      .updateTypeAccount(
        this.copyAccount.map((acc) => acc._id),
        this.selectedEditTypeAccountItems.map((el) => el.value)
      )
      .subscribe((response) => {
        this.getAllType();
        this.getListAccountSeeding();
        this.isLoading = false;
        this.modalRef.hide();
      });
  }

  // lấy ra các tài khoản active
  getListAccountSeeding() {
    this.fbUserSeedingService
      .index(this.typeAccount, this.projectId, this.statusAccount, this.type, this.hasVnptAvt)
      .subscribe((response) => {
        if (response.success) {
          this.fbUserSeedings = response.data.FbUserSeeding;
          this.data = this.fbUserSeedings;
          this.isLoading = false;
        }
      });
  }

  checkUserId() {
    this.userIdErrorMsg = "";
    if (this.fbUserSeeding.userId === "") {
      this.userIdErrorMsg = "Mã tài khoản không được để trống";
    } else {
      const usernamePattern = "^[a-z0-9]{1,15}$";
      if (
        this.fbUserSeeding.userId.toLowerCase().match(usernamePattern) === null
      ) {
        this.userIdErrorMsg = "Mã tài khoản không đúng định dạng";
      }
    }
  }

  checkUsername() {
    this.usernameErrorMsg = "";
    if (this.fbUserSeeding.username === "")
      this.usernameErrorMsg = "Tên tài khoản không được để trống";
    else if (this.fbUserSeeding.username[0] == " ")
      this.usernameErrorMsg = "Tên không được bắt đầu bằng khoảng trắng";
    else
      for (let i = 1; i < this.fbUserSeeding.username.length; i++)
        if (
          this.fbUserSeeding.username[i] == " " &&
          this.fbUserSeeding.username[i - 1] == " "
        )
          this.usernameErrorMsg =
            "Tên không chưa hai kí tự khoảng trắng liên tiếp";
  }

  checkFacebookCookie() {
    this.facebookCookieErrorMsg = "";
    if (this.fbUserSeeding.facebookCookie === "") {
      this.facebookCookieErrorMsg = "Facebook Cookie không được để trống";
    } else {
      if (!this.testJSON(this.fbUserSeeding.facebookCookie)) {
        this.facebookCookieErrorMsg =
          "Facebook cookie vừa nhập không đúng định dạng json";
      }
    }
  }

  testJSON(text) {
    try {
      JSON.parse(text);
      return true;
    } catch (error) {
      return false;
    }
  }

  checkMessengerCookie() {
    this.messengerCookieErrorMsg = "";
    if (this.fbUserSeeding.messengerCookie === "") {
      this.messengerCookieErrorMsg = "Messenger Cookie không được để trống";
    } else {
      if (!this.testJSON(this.fbUserSeeding.messengerCookie)) {
        this.messengerCookieErrorMsg =
          "Messenger cookie vừa nhập không đúng định dạng json";
      }
    }
  }

  checkToken() {
    this.tokenErrorMsg = "";
    if (this.fbUserSeeding.tokenUser === "") {
      this.tokenErrorMsg = "Token không được để trống";
    } else {
      const usernamePattern = "^[a-z0-9._-]{1,400}$";
      if (
        this.fbUserSeeding.tokenUser.toLowerCase().match(usernamePattern) ===
        null
      ) {
        this.tokenErrorMsg = "Token vừa nhập không đúng định dạng";
      }
    }
  }

  checkUserAgent() {
    this.userAgentErrorMsg = "";
    if (this.fbUserSeeding.userAgent === "") {
      this.userAgentErrorMsg = "User Agent không được để trống";
    }
  }

  checkEmail() {
    this.emailErrorMsg = "";
    // if (this.fbUserSeeding.email === '') {
    //   this.emailErrorMsg = 'Email không được để trống';
    // } else {
    const emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
    if (
      this.fbUserSeeding.email.toLowerCase().match(emailPattern) === null &&
      this.fbUserSeeding.email != ""
    ) {
      this.emailErrorMsg = "Email không đúng định dạng!";
    }
    //}
  }

  checkAdminPassword() {
    this.adminPasswordErrorMsg = "";
    if (
      this.isEdit &&
      (this.adminPassword === undefined || this.adminPassword === "")
    ) {
      this.adminPasswordErrorMsg =
        "Bạn phải nhập mật khẩu người quản trị để xác nhận!";
    }
  }

  checkProject() {
    this.projectErrorMsg = "";
    if (this.selectedItems2 === null || this.selectedItems2.length == 0) {
      this.projectErrorMsg = "Chủ đề không được để trống";
    }
  }

  checkVpshosting() {
    this.vpsHostingErrorMsg = "";
    if (this.vpsHostingSelected.length == 0) {
      this.vpsHostingErrorMsg = "VPS Hosting không được để trống";
    }
  }

  public editProject(idParent, fbUserSeeding, template_project): void {
    this.projectSelected = fbUserSeeding.project;
    this.currentProject = JSON.parse(JSON.stringify(fbUserSeeding));
    this.modalRef = this.modalService.show(template_project, this.config2);
    setTimeout(() => {
      $(".pull-left.selected-item-item.btn.btn-default.btn-xs").css({
        border: "1px solid rgba(145, 142, 142, 0.52)",
        color: "black",
      });
      $(".close").css({ "padding-top": "0px", color: "red" });
      $(
        ".btn.btn-default.btn-secondary.form-control.selected-container-item"
      ).css({ height: "40px", border: "1px solid rgba(145, 142, 142, 0.52)" });
    }, 200);
  }

  updateProject() {
    var objProject = [];
    if (this.projectSelected.length > 0) {
      this.projectSelected.forEach(function (project, index) {
        let temp = {};
        temp["id"] = project["id"];
        temp["name"] = project["name"];
        temp["itemName"] = project["name"];
        objProject.push(temp);
      });
    } else {
      this.currentProject["project"] = null;
    }
    this.currentProject["project"] = objProject;
    this.fbUserSeedingService
      .update(this.currentProject["userId"], this.currentProject)
      .subscribe(
        (res) => {
          if (res.success) {
            this.toastrService.success(res.message, "Thông báo");
            this.getListAccountSeeding();
            this.modalRef.hide();
          } else {
            this.toastrService.error(res.message, "Thông báo");
          }
        },
        (err) => {
          this.toastrService.error(
            "Có lỗi xảy ra khi kết nối tới máy chủ!",
            "Thông báo"
          );
        }
      );
  }

  copyAccountSeeding() {
    // danh sách các tài khoản đã chọn để sao chép: this.copyAccount
    // danh sách các chủ đề đã chọn để sao chép: this.copyAccountProjectSelected

    if (
      this.copyAccountProjectSelected.length == 0 ||
      this.copyAccountProjectSelected == null
    ) {
      this.toastrService.warning("Bạn cần chọn ít nhất 1 chủ đề!", "Thông báo");
      return;
    }

    if (this.copyAccount.length > 0) {
      let arrayData = Array();
      arrayData[0] = this.copyAccount;
      arrayData[1] = this.copyAccountProjectSelected;
      this.fbUserSeedingService.copyAccountSeeding(arrayData).subscribe(
        (res) => {
          if (res.success) {
            this.toastrService.success(res.message, "Thông báo");
            this.getListAccountSeeding();
            this.modalRef.hide();
          } else {
            this.toastrService.error(res.message, "Thông báo");
          }
        },
        (err) => {
          this.toastrService.error(
            "Có lỗi xảy ra khi kết nối tới máy chủ!",
            "Thông báo"
          );
        }
      );
    }
  }

  random(min, max) {
    return Math.round(Math.random() * Math.abs(max - min) + min);
  }

  confirmInitAllAccount(template_confirm_init_all) {
    this.modalConfirmInitAll = this.modalService.show(
      template_confirm_init_all,
      this.config3
    );
  }

  deleteType(element, typeStr) {
    if (typeStr === "typeStr" && this.fbUserSeeding.type) {
      this.fbUserSeeding.type.splice(
        this.fbUserSeeding.type.indexOf(element),
        1
      );
    }
  }

  async initAllAccountSeeding() {
    this.isShowProcessBar = true;
    this.modalConfirmInitAll.hide();
    this.totalInit = this.data.length;
    this.initSuccess = 0;
    this.initFail = 0;
    this.percentInit = "0%";
    for (let i = 0; i < this.data.length; i++) {
      let result = await this.initAccount(this.data[i]);
      if (result) {
        this.initSuccess++;
      } else {
        this.initFail++;
      }
      this.percentInit =
        Math.round(
          ((this.initSuccess + this.initFail) / this.totalInit) * 100
        ) + "%";

      const timeDelay = this.random(500, 1000);
      await this.wait(timeDelay);
    }
  }
  /* kiểm tra
  1. đã chọn TĐV chưa
  2. kiểm tra xem 1 trong các tài khoản tương tác này đã được gán vào TDV khác với TĐV đã chọn không
  */
  checkExits(template_confirm) {
    // danh sách các tài khoản đã chọn để gán: this.copyAccount
    // TĐV được chọn: this.accountSelected
    if (this.accountSelected.length == 0) {
      this.toastrService.warning(
        "Bạn chưa chọn tổng đài viên nào!",
        "Thông báo"
      );
      return;
    }
    let result = 0;
    this.userExitsList = "";
    this.copyAccount.forEach((fbUserSeeding) => {
      fbUserSeeding["allowedToChange"] = this.fbUserSeeding.allowedToChange;
      if (
        fbUserSeeding.accountId != this.accountSelected[0]._id &&
        fbUserSeeding.accountId != null
      ) {
        result = 1;
        this.userExitsList += fbUserSeeding.username + ",";
      }
    });

    this.userExitsList = this.userExitsList.substring(
      0,
      this.userExitsList.length - 1
    );

    if (result == 1) {
      this.modalRef.hide();
      this.modalRef1 = this.modalService.show(template_confirm, this.config1);
    } else {
      let arrayData = Array();
      arrayData[0] = this.copyAccount;
      arrayData[1] = this.accountSelected;
      this.fbUserSeedingService.assigneToAccount(arrayData).subscribe(
        (res) => {
          if (res.success) {
            this.toastrService.success(res.message, "Thông báo");
            this.getListAccountSeeding();
            this.modalRef.hide();
          } else {
            this.toastrService.error(res.message, "Thông báo");
          }
        },
        (err) => {
          this.toastrService.error(
            "Có lỗi xảy ra khi kết nối tới máy chủ!",
            "Thông báo"
          );
        }
      );
    }
  }

  assigneToAccount() {
    this.modalRef1.hide();
    let arrayData = Array();
    arrayData[0] = this.copyAccount;
    arrayData[1] = this.accountSelected;
    this.fbUserSeedingService.assigneToAccount(arrayData).subscribe(
      (res) => {
        if (res.success) {
          this.toastrService.success(res.message, "Thông báo");
          this.getListAccountSeeding();
          this.modalRef.hide();
        } else {
          this.toastrService.error(res.message, "Thông báo");
        }
      },
      (err) => {
        this.toastrService.error(
          "Có lỗi xảy ra khi kết nối tới máy chủ!",
          "Thông báo"
        );
      }
    );
  }

  closeModal() {
    this.isLoading = false;
    this.modalRef.hide();
  }

  OnItemDeSelect(item: any) {
    this.getListAccountSeeding();
    this.selectedItems = [{ id: -1, itemName: "Chọn tất cả" }];
  }

  // gán tài khoản cho TĐV
  OnAccountDeSelect(item: any) {}

  onAccountSelect(item: any) {}

  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  onItemSelect(item: any) {
    this.vpsHostingErrorMsg = "";
    if (!this.vpsHostingSelected) {
      this.vpsHostingErrorMsg = "VPS Hosting không được để trống";
    }
  }

  projectSelectedList(item: any) {
    this.projectErrorMsg = "";
    if (this.selectedItems2 === null || this.selectedItems2.length == 0) {
      this.projectErrorMsg = "Chủ đề không được để trống";
    }
  }

  onProjectChange(item: any) {
    if (item.id == -1) {
      this.projectId = "";
      this.getListAccountSeeding();
    } else {
      this.projectId = item._id;
      this.getListAccountSeeding();
    }
  }

  checkValue(event: any) {}

  getCookie(rawCookie) {
    const cookieSplits = rawCookie.split(";");
    const cookies = [];
    for (let cookie of cookieSplits) {
      let split = cookie.split("=");
      if (split[0] === "c_user") {
        cookies.push(this.getCuser(split[1]));
      }

      if (split[0] === "datr") {
        cookies.push(this.getDatr(split[1]));
      }

      if (split[0] === "fr") {
        cookies.push(this.getFr(split[1]));
      }

      if (split[0] === "locale") {
        cookies.push(this.getLocale(split[1]));
      }

      if (split[0] === "m_pixel_ratio") {
        cookies.push(this.getPixel(split[1]));
      }

      if (split[0] === "sb") {
        cookies.push(this.getSb(split[1]));
      }

      if (split[0] === "wd") {
        cookies.push(this.getWd(split[1]));
      }

      if (split[0] === "xs") {
        cookies.push(this.getXs(split[1]));
      }
    }

    return cookies;
  }

  getCuser(value) {
    return {
      domain: ".facebook.com",
      hostOnly: false,
      httpOnly: false,
      name: "c_user",
      path: "/",
      sameSite: "no_restriction",
      secure: true,
      session: false,
      storeId: "0",
      value: value,
      id: 1,
    };
  }

  getDatr(value) {
    return {
      domain: ".facebook.com",
      hostOnly: false,
      httpOnly: true,
      name: "datr",
      path: "/",
      sameSite: "no_restriction",
      secure: true,
      session: false,
      storeId: "0",
      value: value,
      id: 2,
    };
  }

  getFr(value) {
    return {
      domain: ".facebook.com",
      expirationDate: 1627296119.675817,
      hostOnly: false,
      httpOnly: true,
      name: "fr",
      path: "/",
      sameSite: "no_restriction",
      secure: true,
      session: false,
      storeId: "0",
      value: value,
      id: 3,
    };
  }

  getLocale(value) {
    return {
      domain: ".facebook.com",
      expirationDate: 1620124914.042697,
      hostOnly: false,
      httpOnly: false,
      name: "locale",
      path: "/",
      sameSite: "no_restriction",
      secure: true,
      session: false,
      storeId: "0",
      value: value,
      id: 4,
    };
  }

  getPixel(value) {
    return {
      domain: ".facebook.com",
      hostOnly: false,
      httpOnly: false,
      name: "m_pixel_ratio",
      path: "/",
      sameSite: "unspecified",
      secure: true,
      session: true,
      storeId: "0",
      value: value,
      id: 5,
    };
  }

  getSb(value) {
    return {
      domain: ".facebook.com",
      expirationDate: 1682592123.675902,
      hostOnly: false,
      httpOnly: true,
      name: "sb",
      path: "/",
      sameSite: "no_restriction",
      secure: true,
      session: false,
      storeId: "0",
      value: value,
      id: 6,
    };
  }

  getWd(value) {
    return {
      domain: ".facebook.com",
      expirationDate: 1620124925,
      hostOnly: false,
      httpOnly: false,
      name: "wd",
      path: "/",
      sameSite: "lax",
      secure: true,
      session: false,
      storeId: "0",
      value: value,
      id: 7,
    };
  }

  getXs(value) {
    return {
      domain: ".facebook.com",
      expirationDate: 1651056121.675954,
      hostOnly: false,
      httpOnly: true,
      name: "xs",
      path: "/",
      sameSite: "no_restriction",
      secure: true,
      session: false,
      storeId: "0",
      value: value,
      id: 8,
    };
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/fb-user-seeding/fb-user-seeding.component.ts